import { ComponentProps, FC } from 'react'
import { keyframes, styled } from '../../../lib/stitches'
import { useArpMediaStatistics } from '../../../queries/arpMedia'
import Text from '../../core/Text/Text'

const TickerContainer = styled('div', {
  width: '100%',
  background: '$background__primary',
  height: '56px',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: '$gray05',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '$gray05',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
  '&:hover > *': {
    animationPlayState: 'paused'
  },
  variants: {
    variant: {
      dark: {
        borderTopColor: '$gray15',
        borderBottomColor: '$gray15',
        color: '$black',
        fontWeight: 500
      },
      small: {
        height: '40px'
      }
    }
  }
})

const TickerItem = styled(Text, {
  fontFamily: '$mono',
  fontWeight: '$medium',
  letterSpacing: '0.06em',
  margin: '0px 60px',
  whiteSpace: 'nowrap'
})

const animate = keyframes({
  '0%': { transform: 'translateX(0%)' },
  '100%': { transform: 'translateX(-100%)' }
})

const Carousel = styled('div', {
  display: 'flex',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${animate} 30s linear infinite`
})

interface TickerData {
  data: string[]
}

type TickerProps = ComponentProps<typeof TickerContainer> & TickerData

export const Ticker: FC<TickerProps> = ({ data, ...props }) => {
  const arr = new Array(20).fill(true)
  return (
    <TickerContainer {...props}>
      {arr.map((_, i) => (
        <Carousel key={i}>
          {data.map((e) => (
            <TickerItem key={e}>{e}</TickerItem>
          ))}
        </Carousel>
      ))}
    </TickerContainer>
  )
}

const DashboardTicker: FC<ComponentProps<typeof TickerContainer>> = (props) => {
  const { data, isLoading } = useArpMediaStatistics()

  const tickerMessages = isLoading
    ? []
    : [
        `TOTAL SONGS MINTED:   ${data.mintedSongCount}`,
        `TOTAL STEMS MINTED:   ${data.mintedStemCount}`,
        `TOTAL SOUNDS MINTED:   ${data.mintedSampleCount}`
      ]

  return <Ticker data={tickerMessages} {...props} />
}

export default DashboardTicker
